import { render } from "./HomeView.vue?vue&type=template&id=0b03f130&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0b03f130&lang=less&scoped=true"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b03f130"]])

export default __exports__